/* Oz BBQ — site chrome behaviour. Vanilla, no dependencies, deferred.
   Header (sticky hide/reveal, mega menu, predictive search, service ticker),
   mobile drawer, live cart count. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var header = doc.getElementById('AaaHeader');
  if (!header) return;
  var section = doc.getElementById('shopify-section-header') || header;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMq = window.matchMedia('(max-width: 989px)');

  /* ---------------------------------------------------------------------
     Header height token + sticky hide-on-scroll-down / reveal-on-scroll-up
     --------------------------------------------------------------------- */
  var util = header.querySelector('[data-aaa-util]');
  function setHeaderVar() {
    var h = header.offsetHeight - (util ? util.offsetHeight : 0);
    root.style.setProperty('--aaa-header-h', h + 'px');
  }
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar, { passive: true });

  var lastY = window.scrollY;
  var ticking = false;
  var lockReveal = false; // true while a menu/search is open
  function onScroll() {
    var y = window.scrollY;
    var threshold = header.offsetHeight + 120;
    root.classList.toggle('aaa-hdr-stuck', y > (util ? util.offsetHeight : 0));
    root.classList.toggle('aaa-scrolled', y > 480);
    if (lockReveal) {
      root.classList.remove('aaa-hdr-hidden');
    } else if (y > threshold && y > lastY + 4) {
      root.classList.add('aaa-hdr-hidden');
    } else if (y < lastY - 4 || y <= threshold) {
      root.classList.remove('aaa-hdr-hidden');
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  // Keyboard users tabbing into a hidden header get it back.
  header.addEventListener('focusin', function () { root.classList.remove('aaa-hdr-hidden'); });

  /* ---------------------------------------------------------------------
     Mega menu
     --------------------------------------------------------------------- */
  var scrim = header.querySelector('[data-aaa-scrim]');
  var megaItems = Array.prototype.slice.call(header.querySelectorAll('[data-aaa-mega]'));
  var openItem = null;
  var openTimer = null;
  var closeTimer = null;

  function setOpen(item, open) {
    var btn = item.querySelector('[data-aaa-mega-toggle]');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function openMega(item) {
    clearTimeout(closeTimer);
    if (openItem && openItem !== item) setOpen(openItem, false);
    setOpen(item, true);
    openItem = item;
    lockReveal = true;
    if (scrim) scrim.hidden = false;
  }
  function closeMega(returnFocus) {
    clearTimeout(openTimer);
    if (!openItem) return;
    var item = openItem;
    setOpen(item, false);
    openItem = null;
    lockReveal = false;
    if (scrim) scrim.hidden = true;
    if (returnFocus) {
      var btn = item.querySelector('[data-aaa-mega-toggle]');
      if (btn) btn.focus();
    }
  }

  megaItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (mobileMq.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // Small intent delay so sweeping the cursor across the bar doesn't flash panels;
      // once a panel is open, moving between items switches instantly.
      openTimer = setTimeout(function () { openMega(item); }, openItem ? 0 : 110);
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { if (openItem === item) closeMega(false); }, 180);
    });
    var btn = item.querySelector('[data-aaa-mega-toggle]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (openItem === item) { closeMega(false); return; }
        openMega(item);
        var first = item.querySelector('[data-aaa-mega-panel] a');
        if (first && e.detail === 0) first.focus(); // keyboard activation
      });
    }
    item.addEventListener('focusout', function (e) {
      if (openItem === item && !item.contains(e.relatedTarget)) closeMega(false);
    });
  });
  if (scrim) scrim.addEventListener('click', function () { closeMega(false); });

  /* ---------------------------------------------------------------------
     Predictive search
     --------------------------------------------------------------------- */
  var form = header.querySelector('[data-aaa-search]');
  if (form) {
    var input = form.querySelector('[data-aaa-search-input]');
    var panel = form.querySelector('[data-aaa-search-panel]');
    var results = form.querySelector('[data-aaa-search-results]');
    var clearBtn = form.querySelector('[data-aaa-search-clear]');
    var longPh = input.getAttribute('placeholder');
    var shortPh = input.getAttribute('data-placeholder-short');
    var syncPh = function () { if (shortPh) input.setAttribute('placeholder', mobileMq.matches ? shortPh : longPh); };
    syncPh();
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncPh);
    var debounce = null;
    var controller = null;
    var cache = {};
    var activeIndex = -1;

    var cancelBtn = form.querySelector('[data-aaa-search-cancel]');
    // Mobile: the search pill expands across the header row while in use.
    var setExpanded = function (on) { root.classList.toggle('aaa-search-open', !!on && mobileMq.matches); };
    var showPanel = function () {
      setExpanded(true);
      if (!panel.hidden) return;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      lockReveal = true;
      closeMega(false);
    };
    var hidePanel = function () {
      setExpanded(false);
      if (panel.hidden) return;
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      lockReveal = !!openItem;
    };
    var render = function (html) {
      results.innerHTML = html;
      panel.classList.toggle('has-results', html.trim().length > 0);
      activeIndex = -1;
    };
    var fetchResults = function (q) {
      if (cache[q]) { render(cache[q]); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      panel.classList.add('is-loading');
      var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
        'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,query' +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=aaa-predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = text;
          var inner = tmp.querySelector('[data-aaa-ps-results]');
          var html = inner ? inner.outerHTML : '';
          cache[q] = html;
          if (input.value.trim() === q) render(html);
        })
        .catch(function () { /* aborted or offline: keep idle panel */ })
        .then(function () { panel.classList.remove('is-loading'); });
    };

    // Chrome clears type=search on Escape without an input event; keep the × in sync.
    input.addEventListener('search', function () { if (clearBtn) clearBtn.hidden = input.value.length === 0; if (!input.value) render(''); });
    input.addEventListener('focus', showPanel);
    input.addEventListener('click', showPanel);
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = input.value.length === 0;
      showPanel();
      clearTimeout(debounce);
      if (q.length < 2) { render(''); return; }
      debounce = setTimeout(function () { fetchResults(q); }, 160);
    });
    if (clearBtn) {
      clearBtn.hidden = input.value.length === 0;
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        render('');
        input.focus();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () { hidePanel(); input.blur(); });
    }
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', function (e) { if (!e.matches) setExpanded(false); });

    var options = function () {
      return Array.prototype.slice.call(results.querySelectorAll('a'));
    };
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hidePanel(); input.blur(); setTimeout(function () { if (clearBtn) clearBtn.hidden = input.value.length === 0; }, 0); return; }
      var opts = options();
      if (!opts.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      if (e.key === 'Enter') {
        if (activeIndex > -1 && opts[activeIndex]) { e.preventDefault(); window.location.href = opts[activeIndex].href; }
        return;
      }
      e.preventDefault();
      if (opts[activeIndex]) {
        var prevLi = opts[activeIndex].closest('[role="option"]');
        if (prevLi) prevLi.setAttribute('aria-selected', 'false');
        opts[activeIndex].classList.remove('is-active');
      }
      activeIndex = e.key === 'ArrowDown' ? (activeIndex + 1) % opts.length : (activeIndex - 1 + opts.length) % opts.length;
      var el = opts[activeIndex];
      el.classList.add('is-active');
      var li = el.closest('[role="option"]');
      if (li) { li.setAttribute('aria-selected', 'true'); input.setAttribute('aria-activedescendant', li.id); }
      else { input.removeAttribute('aria-activedescendant'); }
      el.scrollIntoView({ block: 'nearest' });
    });

    doc.addEventListener('click', function (e) { if (!form.contains(e.target)) hidePanel(); });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) hidePanel();
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  }

  /* ---------------------------------------------------------------------
     Service-strip ticker (mobile: one fact at a time)
     --------------------------------------------------------------------- */
  var ticker = header.querySelector('[data-aaa-ticker]');
  if (ticker) {
    var facts = ticker.children;
    var idx = 0;
    var paused = false;
    ticker.addEventListener('mouseenter', function () { paused = true; });
    ticker.addEventListener('mouseleave', function () { paused = false; });
    ticker.addEventListener('focusin', function () { paused = true; });
    ticker.addEventListener('focusout', function () { paused = false; });
    if (facts.length > 1) {
      /* Round 6: a pager (one dot per fact, the next-arrow is a 44px button)
         so phones can see there are more messages and step through them. */
      var pager = doc.createElement('div');
      pager.className = 'aaa-util__pager';
      /* Round 8: a "2/4" count instead of dots. A row of pulsing red dots read
         as a loading indicator; a count says "there are more" plainly. */
      var dots = doc.createElement('span');
      dots.className = 'aaa-util__count';
      dots.setAttribute('aria-hidden', 'true');
      var nextBtn = doc.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'aaa-util__next';
      nextBtn.innerHTML = '<svg class="aaa-icon aaa-icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg><span class="aaa-vh">Next store message</span>';
      pager.appendChild(dots);
      pager.appendChild(nextBtn);
      ticker.parentNode.appendChild(pager);
      var show = function (n) {
        facts[idx].classList.remove('is-active');
        idx = (n + facts.length) % facts.length;
        facts[idx].classList.add('is-active');
        dots.textContent = (idx + 1) + '/' + facts.length;
      };
      show(0);
      nextBtn.addEventListener('click', function () { show(idx + 1); });
      setInterval(function () {
        if (paused || !mobileMq.matches || reduceMotion.matches || doc.hidden || header.classList.contains('is-eta-open')) return;
        show(idx + 1);
      }, 4800);
    }
  }

  /* ---------------------------------------------------------------------
     Delivery time by postcode (service strip, fact 1).
     The postcode only selects a row of the published shipping policy's
     per-state transit table; nothing here is a quote or a promise beyond it.
     Remembered in localStorage so the strip reads "Delivering to 3550 ...".
     --------------------------------------------------------------------- */
  var etaBtn = header.querySelector('[data-aaa-eta-open]');
  var etaPop = header.querySelector('[data-aaa-eta]');
  if (etaBtn && etaPop) {
    var etaForm = etaPop.querySelector('[data-aaa-eta-form]');
    var etaInput = etaPop.querySelector('[data-aaa-eta-input]');
    var etaOut = etaPop.querySelector('[data-aaa-eta-out]');
    var etaLabel = etaBtn.querySelector('[data-aaa-eta-label]');
    var ETA = { VIC: '2–4', NSW: '2–4', SA: '2–6', TAS: '2–6', QLD: '4–10', WA: '4–10', NT: '7–10', ACT: '2–10' };
    var stateOf = function (pc) {
      var n = parseInt(pc, 10);
      if (!/^\d{4}$/.test(pc)) return null;
      if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
      if (n >= 800 && n <= 999) return 'NT';
      if (n >= 1000 && n <= 2999) return 'NSW';
      if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
      if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
      if (n >= 5000 && n <= 5999) return 'SA';
      if (n >= 6000 && n <= 6999) return 'WA';
      if (n >= 7000 && n <= 7999) return 'TAS';
      return null;
    };
    var etaText = function (st) {
      return st === 'ACT' ? 'most orders 2–10 business days' : ETA[st] + ' business days';
    };
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var paint = function (pc) {
      var st = stateOf(pc);
      if (!st) return false;
      etaLabel.innerHTML = '<span class="aaa-eta__lead">Delivering to </span><strong>' + esc(st + ' ' + pc) + '</strong><span class="aaa-eta__sep"> · </span><span class="aaa-eta__time">' + etaText(st) + '</span><span class="aaa-eta__change">Change</span>';
      etaBtn.setAttribute('aria-label', 'Delivering to ' + st + ' ' + pc + ', ' + etaText(st) + '. Change postcode');
      return true;
    };
    var saved = null;
    try { saved = localStorage.getItem('aaaPostcode'); } catch (e) {}
    if (saved) { paint(saved); etaInput.value = saved; }

    var etaOpen = function () {
      etaPop.hidden = false;
      etaBtn.setAttribute('aria-expanded', 'true');
      header.classList.add('is-eta-open');
      lockReveal = true;
      setTimeout(function () { etaInput.focus(); etaInput.select(); }, 30);
    };
    var etaClose = function (refocus) {
      if (etaPop.hidden) return;
      etaPop.hidden = true;
      etaBtn.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-eta-open');
      lockReveal = false;
      if (refocus) etaBtn.focus();
    };
    etaBtn.addEventListener('click', function () { if (etaPop.hidden) etaOpen(); else etaClose(false); });
    etaPop.querySelector('[data-aaa-eta-close]').addEventListener('click', function () { etaClose(true); });
    etaPop.addEventListener('keydown', function (e) { if (e.key === 'Escape') etaClose(true); });
    doc.addEventListener('click', function (e) {
      if (!etaPop.hidden && !etaPop.contains(e.target) && !etaBtn.contains(e.target)) etaClose(false);
    });
    etaInput.addEventListener('input', function () { etaInput.value = etaInput.value.replace(/\D/g, '').slice(0, 4); });
    etaForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = etaInput.value.trim();
      var st = stateOf(pc);
      if (!st) {
        etaInput.setAttribute('aria-invalid', 'true');
        etaOut.className = 'aaa-eta__out is-err';
        etaOut.textContent = 'Enter a 4-digit Australian postcode.';
        return;
      }
      etaInput.removeAttribute('aria-invalid');
      try { localStorage.setItem('aaaPostcode', pc); } catch (err) {}
      paint(pc);
      etaOut.className = 'aaa-eta__out is-ok';
      etaOut.innerHTML = '<strong>' + esc(st + ' ' + pc) + ':</strong> ' + etaText(st) + ' once your order leaves the warehouse.';
    });
  }

  /* ---------------------------------------------------------------------
     Drawer
     --------------------------------------------------------------------- */
  var drawer = doc.getElementById('AaaDrawer');
  var burger = header.querySelector('[data-aaa-drawer-open]');
  var lastFocus = null;
  function focusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = doc.activeElement;
    drawer.hidden = false;
    root.classList.add('aaa-no-scroll');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    // next frame so the transition runs from the hidden state
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var panelEl = drawer.querySelector('.aaa-drawer__panel');
        var f = focusables(panelEl);
        (f[1] || f[0] || panelEl).focus();
      });
    });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    root.classList.remove('aaa-no-scroll');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    var done = function () { drawer.hidden = true; };
    if (reduceMotion.matches) done(); else setTimeout(done, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-aaa-drawer-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(drawer.querySelector('.aaa-drawer__panel'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    mobileMq.addEventListener && mobileMq.addEventListener('change', function (e) { if (!e.matches) closeDrawer(); });
  }

  /* Footer link columns: an accordion below 750px, always open above. */
  var accs = Array.prototype.slice.call(doc.querySelectorAll('[data-aaa-ftr-acc]'));
  if (accs.length) {
    var ftrMq = window.matchMedia('(max-width: 749px)');
    var syncAcc = function () { accs.forEach(function (d) { d.open = !ftrMq.matches; }); };
    syncAcc();
    if (ftrMq.addEventListener) ftrMq.addEventListener('change', syncAcc);
    accs.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) { if (!ftrMq.matches) e.preventDefault(); });
    });
  }

  /* Global Escape closes the mega menu */
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) closeMega(true);
  });

  /* ---------------------------------------------------------------------
     Live cart count. Watches the theme's own cart calls (fetch and XHR)
     rather than relying on any one add-to-cart implementation.
     --------------------------------------------------------------------- */
  var countEl = header.querySelector('[data-aaa-cart-count]');
  var cartLink = header.querySelector('[data-aaa-cart-link]');
  var cartRe = /\/cart\/(add|change|update|clear)(\.js)?/;
  var refreshTimer = null;
  function updateCount(n) {
    if (!countEl) return;
    var prev = parseInt(countEl.textContent, 10) || 0;
    countEl.textContent = n;
    countEl.hidden = false;
    countEl.classList.toggle('is-empty', n === 0);
    if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    if (n > prev && !reduceMotion.matches) {
      countEl.classList.remove('is-bump');
      void countEl.offsetWidth;
      countEl.classList.add('is-bump');
    }
  }
  function refreshCart() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { updateCount(c.item_count || 0); })
        .catch(function () {});
    }, 250);
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (resource) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var u = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        if (cartRe.test(u)) p.then(refreshCart, function () {});
      } catch (err) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (cartRe.test(String(url))) this.addEventListener('loadend', refreshCart);
      } catch (err) {}
      return nativeOpen.apply(this, arguments);
    };
  }
  doc.addEventListener('cart:refresh', refreshCart);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();


/* -------------------------------------------------------------------------
   Shopify Inbox chat launcher: icon-only 48px button, bottom-right with
   safe-area offset, hidden until the visitor has scrolled past the hero.
   The launcher lives in open shadow roots (shopify-chat > shopify-agent-runtime),
   so page CSS cannot reach it; a scoped <style> is placed inside instead.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var CSS = [
    ':host{--aaa-chat-show:0}',
    '.activator-nudge{position:fixed!important;right:calc(16px + env(safe-area-inset-right))!important;bottom:calc(16px + env(safe-area-inset-bottom))!important;left:auto!important;top:auto!important;margin:0!important;transition:opacity .28s ease,transform .28s cubic-bezier(.16,1,.3,1),visibility 0s linear .28s;}',
    ':host(:not([data-aaa-chat-show])) .activator-nudge{opacity:0;transform:translateY(16px);visibility:hidden;pointer-events:none}',
    ':host([data-aaa-chat-show]) .activator-nudge{opacity:1;transform:none;visibility:visible;transition-delay:0s}',
    '.activator{width:48px!important;height:48px!important;min-width:0!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important;background:#1C1E20!important;color:#fff!important;box-shadow:0 6px 18px rgba(16,17,18,.24)!important}',
    '.activator:hover{background:#CC0000!important}',
    '.activator:focus-visible{outline:2px solid #CC0000!important;outline-offset:3px!important}',
    '.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important}',
    '@media (prefers-reduced-motion: reduce){.activator-nudge{transition:none!important}}'
  ].join('');
  var runtime = null;
  function sync() {
    if (!runtime) return;
    var open = runtime.shadowRoot && runtime.shadowRoot.querySelector('.activator[aria-expanded="true"]');
    var show = root.classList.contains('aaa-scrolled') || !!open;
    if (show) runtime.setAttribute('data-aaa-chat-show', ''); else runtime.removeAttribute('data-aaa-chat-show');
  }
  function attach() {
    var host = doc.querySelector('shopify-chat');
    var rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    if (!rt || !rt.shadowRoot || !rt.shadowRoot.querySelector('.activator')) return false;
    if (!rt.shadowRoot.querySelector('style[data-aaa-chat]')) {
      var st = doc.createElement('style');
      st.setAttribute('data-aaa-chat', '');
      st.textContent = CSS;
      rt.shadowRoot.appendChild(st);
    }
    runtime = rt;
    sync();
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
    return true;
  }
  var tries = 0;
  (function poll() {
    if (attach() || ++tries > 60) return;
    setTimeout(poll, 500);
  })();
})();

/* -------------------------------------------------------------------------
   Homepage: the featured-blog section ships without a heading. Give it a
   real section head ("Guides & cook notes" + link to every guide).
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var doc = document;
  if (doc.body.getAttribute('data-aaa-tpl') !== 'index') return;
  var inner = doc.querySelector('.section-featured-blog .content.blog .inner');
  if (!inner || inner.querySelector('.aaa-hp-head') || inner.querySelector('.shopify-section-title')) return;
  var first = inner.querySelector('.post a[href*="/blogs/"]');
  var blogUrl = first ? first.getAttribute('href').split('/').slice(0, 3).join('/') : '/blogs/expert-advice';
  var head = doc.createElement('div');
  head.className = 'aaa-hp-head';
  head.innerHTML = '<div><span class="aaa-hp-head__kicker">From the pit</span><h2>Guides &amp; cook notes</h2></div>' +
    '<a href="' + blogUrl + '">All guides</a>';
  inner.insertBefore(head, inner.firstChild);
})();

/* -------------------------------------------------------------------------
   Product rails (homepage): arrow paging + quick add for single-variant
   products. The header cart count updates itself from the /cart/add call.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(doc.querySelectorAll('[data-aaa-rail]'), function (rail) {
    var track = rail.querySelector('[data-aaa-rail-track]');
    var prev = rail.querySelector('[data-aaa-rail-prev]');
    var next = rail.querySelector('[data-aaa-rail-next]');
    if (!track || !prev || !next) return;
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      rail.classList.toggle('is-static', max <= 0);
    };
    var page = function (dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-aaa-quick-add]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = form.querySelector('.aaa-pc__add-label');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-busy');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added to cart';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = 'Add to cart';
        }, 2600);
      })
      .catch(function () { form.submit(); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();


/* -------------------------------------------------------------------------
   Lazy-image safety net (all pages).
   Native loading="lazy" relies on the browser's own distance threshold,
   which on phones (and in some in-app browsers and page captures) can leave
   tiles a long way down blank. Two passes, both after first paint, so the
   LCP image is never competed with:
     1. An IntersectionObserver with a generous 2000px rootMargin flips any
        lazy image nearing the viewport to eager.
     2. Once the page has loaded and the main thread is idle, the rest of
        the page's lazy images are flipped in small batches.
   Images inside the closed mega panels and drawer are left alone.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (!('loading' in HTMLImageElement.prototype)) return;
  var SKIP = '.aaa-mega, .aaa-drawer, [hidden], template';
  function pending() {
    return Array.prototype.filter.call(document.querySelectorAll('img[loading="lazy"]'), function (img) {
      return !img.closest(SKIP);
    });
  }
  function wake(img) { if (img.loading === 'lazy') img.loading = 'eager'; }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { wake(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '2000px 0px' });
    var watch = function () { pending().forEach(function (img) { io.observe(img); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function sweep() {
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    var list = pending();
    var i = 0;
    (function batch() {
      list.slice(i, i + 6).forEach(wake);
      i += 6;
      if (i < list.length) setTimeout(function () { idle(batch); }, 250);
    })();
  }
  /* Round 7: don't wait on window.load alone. Third-party tags can hold it
     back for many seconds on desktop, which left the lower page blank in
     captures and for fast scrollers. Sweep at load or 2.5s after the DOM is
     ready, whichever comes first. */
  var swept = false;
  function afterLoad() { if (swept) return; swept = true; setTimeout(function () { idle(sweep); }, 600); }
  if (document.readyState === 'complete') afterLoad();
  else {
    window.addEventListener('load', afterLoad);
    var early = function () { setTimeout(afterLoad, 2500); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', early); else early();
  }
})();
